module.exports = __webpack_public_path__ + "img/ht_icon_upload.b76ceb26.svg";